var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.37291 8.90339L14.5431 9.09597C15.4339 9.109 15.8958 8.0385 15.2751 7.39939L8.78628 0.718011C8.4015 0.321819 7.76841 0.31256 7.37222 0.697333L0.69084 7.18612C0.0517318 7.80681 0.4821 8.89036 1.37291 8.90339Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpPrimary);
export default __webpack_public_path__ + "static/media/ArrowUpPrimary.1e9e867326cf35579665622d2337ded3.svg";
export { ForwardRef as ReactComponent };